interface Routes {
  home: string;
  question: (questionPath: string) => string;
  results: string;
  state: string;
  resultsRestored: string;
  resultsRestoredSequence: string;
  createAccount: string;
  clinicCheckout: string;
  clinicCheckoutPlans: string;
  clinicCheckoutTreatmentOptions: string;
  clinicCheckoutPayment: string;
  medicalHistory: string;
}

const routes: Routes = {
  home: "/",
  question: questionPath => `/${questionPath}`,
  results: "/results",
  state: "/state",
  resultsRestored: "/results-restored",
  resultsRestoredSequence: "/results-sequence",
  createAccount: "/create-account",
  clinicCheckout: "/clinic/checkout",
  clinicCheckoutPlans: "/clinic/checkout/plan",
  clinicCheckoutTreatmentOptions: "/clinic/checkout/treatment-options",
  clinicCheckoutPayment: "/clinic/checkout/payment",
  medicalHistory: "/medical-history"
};

export default routes;
